export const orgTypes = 'orgTypes';
